<template>

    <BaseContainer>

        <header class="mb-6">

            <h1 class="text-gray-800 font-bold text-xl leading-none mb-2" v-text="$t('labels.grades')"></h1>

            <Breadcrumbs :current="Route.GRADE_INDEX"/>

        </header>

        <DataTable
            v-model:page="page"
            id="grades"
            :filterable="false"
            :columns="columns"
            :rows="rows"
            :to="to"
            :from="from"
            :total="total"
            :pages="pages"
            :loading="loading"
            :filter="filter"
            :viewable="false"
            :transform="transform"
            @edit="edit"
            @destroy="destroy">

            <template #actions>
                <BaseButton @click.prevent="create()"><i class="fa-duotone fa-circle-plus mr-2"></i>{{ $t('labels.grade-create') }}</BaseButton>
            </template>

        </DataTable>

        <BaseDrawer :title="$t(form?.mode === 'edit' ? 'labels.grade-edit' : 'labels.grade-create')">
            <GradeForm ref="form"/>
        </BaseDrawer>

    </BaseContainer>

</template>

<script setup>
    import Route from '@/constants/route'
    import { useI18n, useTrans } from '@/composables/i18n'
    import { useModelIndex } from '@/composables/model-ui'
    import { useGradeStore } from '@/store/model'

    const { t } = useI18n()
    const trans = useTrans()
    const store = useGradeStore()

    const { rows, from, to, total, page, pages, loading, search, filter, destroy } = useModelIndex('grade', store, {
        created: t('message.grade-created'),
        updated: t('message.grade-updated'),
        destroyed: t('message.grade-destroyed')
    })

    const columns = computed(() => [
        { id: 'id', text: t('labels.id') },
        { id: 'name_en', text: t('labels.name-en') },
        { id: 'name_fr', text: t('labels.name-fr') },
        { id: 'abbreviation_en', text: t('labels.abbreviation-en') },
        { id: 'abbreviation_fr', text: t('labels.abbreviation-fr') },
        { id: 'created_at', text: t('labels.created') },
        { id: 'updated_at', text: t('labels.updated') },
    ])

    const form = ref()
    const create = () => form.value?.create()
    const edit = (id) => form.value?.edit(id)

    /**
     * Transform the specified row.
     *
     * @param {String} column
     * @param {Object} row
     * @return {String}
     */
     function transform (column, row) {     
        switch (column) {
            case 'abbreviation': return trans({ en: row.abbreviation_en, fr: row.abbreviation_fr })
            case 'name': return trans({ en: row.name_en, fr: row.name_fr })
        }
        
        return row?.[column] || ''
     }
</script>
